<script lang="ts">
    import { Splide, SplideSlide } from "@splidejs/svelte-splide"
    import "@splidejs/svelte-splide/css"

    import { getCachedEntries } from "../../../api"
    import TeamMemberArticle from "./Team_MemberArticle.svelte"

    export let block: ContentBlockEntry

    let loading = true
    let team: TeamEntry[]

    getCachedEntries("team").then((data) => {
        loading = true
        team = data
        loading = false
    })
</script>

<!--
        Team Modul
        - hier muss nur bedacht werden, dass es zwei verschiedene Darstellungen gibt: Slider und Grid
    -->
<div class="container">
    {#if loading}
        <div class="loader"></div>
    {:else if team?.length}
        <div class="team-{block.team?.type || 'slider'} bp-xl">
            <!-- .team-slider ist der Indikator für den Slider selbst, alternativ .team-grid für die Übersichtsseite -->
            {#if block.team?.type == "grid"}
                {#each team as member}
                    <TeamMemberArticle {member} />
                {/each}
            {:else}
                <Splide
                    options="{{
                        perPage: 3,
                        pagination: false,
                        width: '100%',
                        breakpoints: {
                            768: { perPage: 2 },
                            480: { perPage: 1 },
                        },
                    }}"
                >
                    {#each team as member}
                        <SplideSlide>
                            <TeamMemberArticle {member} />
                        </SplideSlide>
                    {/each}
                </Splide>
            {/if}
        </div>
    {/if}
</div>
